<i
  *ngIf="!!sport"
  [ngClass]="{
    'm-0': noMargin,
  }"
  class="sb-sport-icon codere-icon color-dark icon-{{this.sport}}"
></i>
